export enum CuratedListType {
    Artists = 'artists',
    Genres = 'genres',
    Groups = 'groups',
    Instruments = 'instruments',
    Labels = 'labels',
    Packs = 'packs',
    Repacks = 'repacks',
    Samples = 'samples',
}

export interface CuratedList<T = string> {
    guid: string;
    name: string;
    code?: string;
    description: string;
    type: CuratedListType;
    data: T[];
}
